import { makeAutoObservable, observable } from 'mobx';
import {
  ChatGroupInterface,
  LastMessageInfo,
  MessageDetailsInterface,
  UserInterface
} from '../../interfaces/chatMessageInterface';

export interface RawChatGroup {
  id: string;
  name: string;
  companyId?: string;
  lastMessage?: LastMessageInfo | null;
  createdOn?: string;
  createdBy?: string;
  updatedBy?: string;
  updatedOn?: string;
  users?: UserInterface[];
  type?: number;
  messages: MessageDetailsInterface[];
  lastMessageTime?: string;
  lastMessageText?: string;
  profilePic?: string;
  order?: number;
  pinned?: boolean;
  lastSeen?: { [key: string]: string };
  hasUnreadMessages?: boolean;
  unreadCount?: number;
}

export class ChatGroupModel {
  id: string;
  name: string;
  companyId?: string;
  createdOn?: string;
  createdBy?: string;
  updatedBy?: string;
  updatedOn?: string;
  users?: UserInterface[];
  type?: number;
  messages: MessageDetailsInterface[];
  lastMessage?: LastMessageInfo | null;
  lastMessageTime?: string;
  lastMessageText?: string;
  profilePic?: string;
  order?: number;
  pinned?: boolean;
  lastSeen?: { [key: string]: string };
  hasUnreadMessages?: boolean;
  unreadCount?: number;

  constructor(rawChatGroup: RawChatGroup) {
    makeAutoObservable(this, {
      // Use shallow observable for messages array to prevent deep observation of nested objects
      // This significantly improves performance when dealing with many messages
      messages: observable.shallow
    });

    this.id = rawChatGroup.id;
    this.name = rawChatGroup.name;
    this.companyId = rawChatGroup.companyId;
    this.createdOn = rawChatGroup.createdOn;
    this.createdBy = rawChatGroup.createdBy;
    this.updatedBy = rawChatGroup.updatedBy;
    this.updatedOn = rawChatGroup.updatedOn;
    this.users = rawChatGroup.users;
    this.type = rawChatGroup.type;
    this.messages = rawChatGroup.messages || [];
    this.lastMessage = rawChatGroup.lastMessage;
    this.lastMessageTime = rawChatGroup.lastMessageTime;
    this.lastMessageText = rawChatGroup.lastMessageText;
    this.profilePic = rawChatGroup.profilePic;
    this.order = rawChatGroup.order;
    this.pinned = rawChatGroup.pinned;
    this.lastSeen = rawChatGroup.lastSeen;
    this.hasUnreadMessages = rawChatGroup.hasUnreadMessages;
    this.unreadCount = rawChatGroup.unreadCount;
  }

  updateName(name: string) {
    this.name = name;
  }
}

export const createObservableChatGroup = (rawChatGroup: RawChatGroup | ChatGroupInterface) => {
  return new ChatGroupModel(rawChatGroup as RawChatGroup);
};
